(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["curiosa-studio-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('curiosa-studio-video')) {
  customElements.define('curiosa-studio-video', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const video=this.querySelector('video'), button=this.querySelector('button');
      if (!video || !button) return;
      this.ready=true;
      const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
      let wanted=this.dataset.auto==='true' && !reduced.matches && !navigator.connection?.saveData;
      let visible=false;
      const update=()=>{
        button.querySelector('.cs-film__action').textContent=video.paused?this.dataset.play:this.dataset.pause;
        button.querySelector('.cs-film__symbol').textContent=video.paused?'▶':'Ⅱ';
      };
      const play=()=>video.play().catch(()=>update());
      video.controls=false;
      button.hidden=false;
      button.addEventListener('click',()=>{
        wanted=video.paused;
        if(wanted) play(); else video.pause();
      });
      video.addEventListener('play',update);
      video.addEventListener('pause',update);
      this.observer=new IntersectionObserver(entries=>{
        visible=entries[0].isIntersecting;
        if(visible && wanted && !document.hidden) play(); else video.pause();
      },{threshold:0.2});
      this.observer.observe(this);
      this.visibility=()=>{
        if(document.hidden) video.pause(); else if(visible && wanted) play();
      };
      document.addEventListener('visibilitychange',this.visibility);
      this.motion=()=>{if(reduced.matches){wanted=false;video.pause();}};
      reduced.addEventListener('change',this.motion);
      this.reduced=reduced;
      update();
    }
    disconnectedCallback(){
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange',this.visibility);
      this.reduced?.removeEventListener('change',this.motion);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
